module.exports = __webpack_public_path__ + "img/232.2f875fa7.svg";